import { LANE_IDS, type GameState, type LaneId, type PlayerId } from "../types";

export const BASE_EVENT_LIMIT = 1;
export const MAXIMUM_EVENT_LIMIT = 4;

export interface EventLimitSnapshot {
  readonly limit: number;
  readonly eventsPlayed: number;
  readonly remaining: number;
  readonly authorizingCommanderLanes: readonly LaneId[];
}

export function getActiveCommanderLanes(
  state: Readonly<GameState>,
  playerId: PlayerId,
): readonly LaneId[] {
  return LANE_IDS.filter((laneId) => {
    const lane = state.lanes[laneId];
    const side = lane.players[playerId];
    return lane.result === "active" && side.status === "active" && side.commander !== null;
  });
}

export function calculateEventLimit(state: Readonly<GameState>, playerId: PlayerId): number {
  return Math.min(
    MAXIMUM_EVENT_LIMIT,
    BASE_EVENT_LIMIT + getActiveCommanderLanes(state, playerId).length,
  );
}

export function getEventLimitSnapshot(
  state: Readonly<GameState>,
  playerId: PlayerId,
): EventLimitSnapshot {
  const authorizingCommanderLanes = getActiveCommanderLanes(state, playerId);
  const limit = Math.min(MAXIMUM_EVENT_LIMIT, BASE_EVENT_LIMIT + authorizingCommanderLanes.length);
  const eventsPlayed = state.players[playerId].actionsUsed.eventsPlayed;

  return {
    limit,
    eventsPlayed,
    remaining: Math.max(0, limit - eventsPlayed),
    authorizingCommanderLanes,
  };
}
